export interface ICountryCode {
  code: string;
  label: string;
  /** Regex pattern for validating the local phone number (without country code) */
  pattern: RegExp;
  /** Example local number for placeholder */
  example: string;
  /** Min digits for the local number */
  minLength: number;
  /** Max digits for the local number */
  maxLength: number;
}

export const COUNTRY_CODES: ICountryCode[] = [
  {
    code: '852',
    label: '🇭🇰 +852',
    pattern: /^[2-9]\d{7}$/,
    example: '91234567',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: '971',
    label: '🇦🇪 +971',
    pattern: /^[0-9]{7,9}$/,
    example: '501234567',
    minLength: 7,
    maxLength: 9,
  },
  {
    code: '44',
    label: '🇬🇧 +44',
    pattern: /^[0-9]{10,11}$/,
    example: '7911123456',
    minLength: 10,
    maxLength: 11,
  },
  {
    code: '86',
    label: '🇨🇳 +86',
    pattern: /^1\d{10}$/,
    example: '13812345678',
    minLength: 11,
    maxLength: 11,
  },
  {
    code: '55',
    label: '🇧🇷 +55',
    pattern: /^[0-9]{10,11}$/,
    example: '11912345678',
    minLength: 10,
    maxLength: 11,
  },
  {
    code: '66',
    label: '🇹🇭 +66',
    pattern: /^[0-9]{8,9}$/,
    example: '812345678',
    minLength: 8,
    maxLength: 9,
  },
  {
    code: '84',
    label: '🇻🇳 +84',
    pattern: /^[0-9]{9,10}$/,
    example: '912345678',
    minLength: 9,
    maxLength: 10,
  },
  {
    code: '63',
    label: '🇵🇭 +63',
    pattern: /^[0-9]{10}$/,
    example: '9171234567',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: '60',
    label: '🇲🇾 +60',
    pattern: /^[0-9]{9,10}$/,
    example: '123456789',
    minLength: 9,
    maxLength: 10,
  },
  {
    code: '65',
    label: '🇸🇬 +65',
    pattern: /^[689]\d{7}$/,
    example: '81234567',
    minLength: 8,
    maxLength: 8,
  },
];

export const DEFAULT_COUNTRY_CODE = '86';

/**
 * Validate a phone number against its country code rules.
 * Returns true if valid, false otherwise.
 */
export const validatePhoneByCountry = (
  countryCode: string,
  phoneNumber: string,
): boolean => {
  const country = COUNTRY_CODES.find((c) => c.code === countryCode);

  if (!country) {
    // Fallback: allow 6-15 digits for unknown country codes
    return /^[0-9]{6,15}$/.test(phoneNumber);
  }

  return country.pattern.test(phoneNumber);
};

/**
 * Get the placeholder example for a country code.
 */
export const getPhonePlaceholder = (countryCode: string): string => {
  const country = COUNTRY_CODES.find((c) => c.code === countryCode);
  return country?.example || '123456789';
};
